// components/CurrentDate.tsx
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function DateDisplay({
  date = new Date(),
  className,
}: {
  date?: Date
  className?: string
}) {
  // Lấy ngày hiện tại

  // Định dạng ngày theo kiểu `Thứ, ngày/tháng/năm`
  const dateDisplay = date.toLocaleDateString('vi-VN', {
    day: '2-digit', // Ngày
    month: '2-digit', // Tháng
    year: 'numeric', // Năm
  })

  return (
    <div className={` ${className}`}>
      <FontAwesomeIcon icon={faCalendar} className="mr-2" />
      <time>{dateDisplay}</time>
    </div>
  )
}
